// extracted by mini-css-extract-plugin
export default {"wrapper":"qDJlQ4Cy_0nwruebdrGe","titleWithCurrency":"yUkBmFWj4ulGeywFDvcS","title":"loXoxvCUxTXQPYj4vll1","currencySelect":"d9hby5CkDsX9kjbHKkJQ"};